var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"m-0 p-0 d-flex flex-row justify-content-between",attrs:{"fluid":""}},[_c('div',{staticClass:"vh-100 overflow-auto flex-grow-1"},[_c('version-updated-notification-bar'),_c('page-navbar'),_c('router-view'),_c('page-footer')],1),_c('fast-navigation-sidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }